// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"e49a2678","703":"a2f31d99"}[chunkId] + ".chunk.js";
};